import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../services/i18nService';

const AnnotationItemRemovedAlert = ({ isHighlight, extraClasses, id, styles }) => {
    const message = isHighlight ? t('alert.removedHighlightItem') : t('alert.removedAnnotationItem');
    return (
        <div className={`${extraClasses} annotationItemRemovedAlertWrapper`} id={id} style={styles} role="alert">
            <p>
                {message}
            </p>
        </div>
    );
};

AnnotationItemRemovedAlert.propTypes = {
    isHighlight: PropTypes.bool.isRequired,
    extraClasses: PropTypes.string,
    id: PropTypes.string,
    styles: PropTypes.object,
};

export default AnnotationItemRemovedAlert;
